
export const getExpiresIn = (createdAtString) => {
    const createdAt = new Date(createdAtString);
    const expiresAt = new Date(createdAt.getTime() + 24 * 60 * 60 * 1000); // +24h
    const now = new Date();
    const timeLeftMs = expiresAt - now;

    if (timeLeftMs <= 0) return { text: "Isteklo", hoursLeft: 0 };

    const hours = Math.floor(timeLeftMs / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeftMs % (1000 * 60 * 60)) / (1000 * 60));

    let text = "";

    if (hours > 0) {
        if (hours === 1) text = `${hours} sat`;
        else if (hours >= 2 && hours <= 4) text = `${hours} sata`;
        else text = `${hours} sati`;
    } else if (minutes > 0) {
        text = minutes === 1 ? `${minutes} minut` : `${minutes} minuta`;
    } else {
        text = "Uskoro ističe";
    }

    return { text, hoursLeft: hours };
};
